import { CHAT_HISTORY_LIST_TAG, LIST_QUERY_CACHE_TTL_SECONDS } from '../constants';
import { api } from '../core';

export interface ChatHistoryData {
  title: string;
  chatId: string;
  lastUpdated: string;
  latestActivity: string;
  createdAt: string;
  user: string;
  userId: string;
  caseRef: string;
  isDraft: boolean;
}

export interface GetChatHistoryResponse {
  numberOfResults: number;
  chats: ChatHistoryData[];
}

export interface GetChatHistoryRequest {
  search?: string;
  caseReferences?: string[];
  pageIndex?: number;
  pageSize?: number;
  sortBy?: 'latest_activity' | 'created_at';
  sortDirection?: 'ascending' | 'descending';
}

export const getChatHistoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChatHistory: builder.query<GetChatHistoryResponse, GetChatHistoryRequest>({
      query: ({ search, caseReferences, pageIndex, pageSize, sortBy, sortDirection }) => {
        const params = new URLSearchParams({});

        if (search) {
          params.set('title_keywords', search);
        }
        if (caseReferences?.length) {
          params.append('case_references', caseReferences.join(','));
        }
        if (pageIndex !== undefined) {
          params.set('page_index', String(pageIndex));
        }
        if (pageSize !== undefined) {
          params.set('page_size', String(pageSize));
        }
        if (sortBy) {
          params.set('sort_by', sortBy);
        }
        if (sortDirection) {
          params.set('sort_direction', sortDirection);
        }

        return {
          url: `chats`,
          method: 'GET',
          params,
        };
      },
      providesTags: () => [{ type: CHAT_HISTORY_LIST_TAG }],
      extraOptions: { maxRetries: 3 },
      keepUnusedDataFor: LIST_QUERY_CACHE_TTL_SECONDS,
    }),
  }),
});

export const { useLazyGetChatHistoryQuery } = getChatHistoryApi;
